$(function () {

  const totalPrice = $('#total_price');

  if (!totalPrice) { return }

  function calculateTotalPrice() {
    let price = 0;
    const multiplier = parseFloat(totalPrice.attr('data-multiplier')) < 1 ? 1 : totalPrice.attr('data-multiplier');
    $('#payment-form input:checked').parent().find('.toggle_percent').each(function () {
      price += parseFloat(this.innerText);
    });
    price *= multiplier || 1;
    price = price < 1 ? 1 : price;
    totalPrice.text(`$${price}`);
  }

  calculateTotalPrice();

  $('#payment-form').on('change', function () {
    calculateTotalPrice();
  })

});

$(function () {
  $('.promotion-help').on('click', function () {
    let visibleTooltip = $('.post-help-head:visible');
    let clickedTooltip = $(this).parent().find('.post-help-head');

    visibleTooltip.toggle('hide');
    if (!visibleTooltip.is(clickedTooltip)) {
      clickedTooltip.toggle('show');
    }
  });

  $('.promotion-button-close').on('click', function () {
    $(this).parent().toggle('hide');
  });
});

$(function () {
  $('#payment-form input:checkbox').on('change', function () {
    var checked = $(this).is(':checked');
    $('input[name="' + this.name + '"]').prop('checked', false);
    if (checked || $('#payment-form input:checkbox:checked').length < 1) {
      $(this).prop('checked', true);
    }
  });
});

$(function () {
  $('#payment-form').on('submit', function (e) {
    e.preventDefault();
  })
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/promotions.js